import { render } from "./JobPostingsTable.vue?vue&type=template&id=eb7fb44c"
import script from "./JobPostingsTable.vue?vue&type=script&lang=js"
export * from "./JobPostingsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__